// extracted by mini-css-extract-plugin
module.exports = {"casesList":"style_casesList__Ms3U_"};